import { FC, useContext } from "react";
import { Button } from "components/atoms/Button";
import { ButtonType } from "components/atoms/Button/types";
import { Modal } from "components/atoms/Modal/index";
import { AppContext } from "lib/contexts";
import { AppReducerActionType } from "types";
import { Span, SubTitle, Text } from "utils/styling/typography.styled";
import { Container, ModalContainer } from "./PresetSubscriptionModal.styled";
interface PresetSubscriptionModalProps {
  isOpen: boolean;
  onCancel: () => void;
}
export const PresetSubscriptionModal: FC<PresetSubscriptionModalProps> = ({
  isOpen,
  onCancel
}) => {
  const {
    state,
    dispatch
  } = useContext(AppContext);
  const handleSubscribeClick = () => {
    dispatch({
      type: AppReducerActionType.SHOW_SUBSCRIPTION_TABLE,
      payload: {
        ...state,
        showSubscriptionTable: !state.showSubscriptionTable
      }
    });
  };
  return <Modal open={isOpen} handleBackdropClick={onCancel} disableBackdropClick data-sentry-element="Modal" data-sentry-component="PresetSubscriptionModal" data-sentry-source-file="index.tsx">
            <ModalContainer data-sentry-element="ModalContainer" data-sentry-source-file="index.tsx">
                <SubTitle data-sentry-element="SubTitle" data-sentry-source-file="index.tsx">Presets</SubTitle>
                <Text data-sentry-element="Text" data-sentry-source-file="index.tsx">
                    To unlock and use the presets feature, please subscribe.
                    Enjoy enhanced functionality and personalized experiences by
                    upgrading your account today.
                </Text>
                <hr />
                <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
                    <Button onClick={handleSubscribeClick} variant={ButtonType.SUCCESS} type="button" data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Subscribe</Span>
                    </Button>
                    <Button type="button" variant={ButtonType.PRIMARY} onClick={onCancel} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Cancel</Span>
                    </Button>
                </Container>
            </ModalContainer>
        </Modal>;
};